<script>
	import "./scss/main.scss";
	import * as Pages from './pages';
	import { asyncErrorHandler, getServer, getUnsentReport, setSentReport, getUnsentMedia, setSentMedia, getMediaDb, fetchData } from './components/shared/utils/Data.svelte';
	import * as pannellum from '../vendor/pannellum';
	import "../vendor/pannellum.css";
	import 'iv-viewer/dist/iv-viewer.css';
	import { initializeApp } from 'firebase/app';
	import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

	export let page;
	export let data;
	export let vitals = {};
	let messageToken = "";
	let token = "";
	vitals.online = true;
	vitals.version = "v1.1.248";

  if ('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/service-worker.js');
		navigator.serviceWorker.addEventListener('controllerchange',
			function() {
				window.location.reload();
			}
		);
	}
	
  if (navigator.userAgent.substring(0, 13) == "GeoSync Cloud" && navigator.userAgent.search("|") != -1) {
		var agent = navigator.userAgent.substring(16).split("|");
		window.platform = agent[0];
		if (agent.length == 2) {
			window.apiVersion = agent[1];
		}
	}

	async function messageHandler(message) {
		if (message.detail.type == "poll") {
			if (message.detail.data) {
				token = message.detail.data;
			}
			else {
				token = "";
			}
		}
	}

	if (window.platform == "Android" && window.apiVersion  >= 6) {
		messageToken = androidAdapter.getMessageToken();
	}
	else {
		isSupported().then(function (result) {
			if (!result)
				return;

			const firebaseApp = initializeApp({
				apiKey: "AIzaSyCSzykHHjjP1YWIYzn3qFdqVGp13p_zH1A",
				authDomain: "geosync-cloud-1558625803076.firebaseapp.com",
				databaseURL: "https://geosync-cloud-1558625803076.firebaseio.com",
				projectId: "geosync-cloud-1558625803076",
				storageBucket: "geosync-cloud-1558625803076.appspot.com",
				messagingSenderId: "714169959670",
				appId: "1:714169959670:web:277f1cda0c20caf7e498d7"
			});

			const messaging = getMessaging(firebaseApp);
			if ("Notification" in window) {
				Notification.requestPermission().then((permission) => {
					if (permission === 'granted') {
						getToken(messaging, { vapidKey: "BD3d3sJgwwwRSCwUj8VcvexIu-zyFy3PSn3r8k7e4m8DOwmklFLyTwr93rhwCebwbIdrfchX7WbzPZAyELoEWas"}).then((currentToken) => {
							if (currentToken) {
								messageToken = currentToken;
							}
						})
					}
				});
			}

			onMessage(messaging, (payload) => {
				const notification = new Notification(payload.notification.title, {
					body: payload.notification.body,
				});
			});
		})
	}
	

	function dataURLToBlob(dataURL) {
			var BASE64_MARKER = ';base64,';
			if (dataURL.indexOf(BASE64_MARKER) == -1) {
				var parts = dataURL.split(',');
				var contentType = parts[0].split(':')[1];
				var raw = parts[1];

				return new Blob([raw], {type: contentType});
			}

			var parts = dataURL.split(BASE64_MARKER);
			var contentType = parts[0].split(':')[1];
			var raw = window.atob(parts[1]);
			var rawLength = raw.length;

			var uInt8Array = new Uint8Array(rawLength);

			for (var i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}

			return new Blob([uInt8Array], {type: contentType});
	}

	const sleep = m => new Promise(r => setTimeout(r, m))
	async function poll() {
		var delay = 60000;
		const [res, err] = await asyncErrorHandler(fetch(getServer() + "/offline.gif?t=" + new Date().getTime()));
		if (err || res.status != 200) {
			vitals.online = false;
		}
		else {
			vitals.online = true;
			if (token) {
				var report = getUnsentReport();
				if (report) {
					let [res, err] = await fetchData("/v1/reports", {
						method: "POST",
									headers: {
											'Accept': 'application/json',
											'Content-Type': 'application/json',
											'Authorization': 'Bearer ' + token
									},
									body: JSON.stringify({
							metadata: report.metadata,
							feature: report.feature
						})
					});
					if (!err) {
						setSentReport(report);
						await poll();
						return;
					}
				} else {
					var media = getUnsentMedia();
					if (media) {
						let data = new FormData();
						data.append("name", media.name);
						data.append("description", media.description);
						data.append("group", media.group);
						data.append("filename", media.filename);
						data.append("type", media.type);
						if (media.type === "link") {
								data.append("link", link);
								let [res, err]  = await fetchData("/v1/media" + media.path, {
										method: "POST",
										headers: {
												'Accept': 'application/json',
												'Authorization': 'Bearer ' + token
										},
											body: data
									});
									if (!err) {
										setSentMedia(media);
										await poll();
										return;
									}
						}
						else {
								var transaction = getMediaDb().transaction(["media"], "readwrite");
								transaction.objectStore("media").get(media.id).onsuccess = async function (event) {
									data.append("files", dataURLToBlob(event.target.result), media.filename);
									let [res, err]  = await fetchData("/v1/media" + media.path, {
										method: "POST",
										headers: {
												'Accept': 'application/json',
												'Authorization': 'Bearer ' + token
										},
											body: data
									});

									if (!err) {
										setSentMedia(media);
										await poll();
										return;
									}
								};
						}
					}
				}
			}
		}

		await sleep(delay);
		await poll();	
	}
	poll();
</script>

<main>
	{#if page}
		<svelte:component this={Pages[page]} page={page} data={data} vitals={vitals} messageToken={messageToken} on:message={messageHandler} />
	{/if}
</main>